import { useI18n } from '../composables/i18n.composable';

export function* keyIterator(i18nKey: string): Generator<string> {
  const { t, exists } = useI18n();
  let index = 0;

  while (true) {
    if (exists(`${i18nKey}.${index}`, { detectEmpty: true })) {
      yield t(`${i18nKey}.${index++}`, { detectEmpty: true });
    } else {
      return;
    }
  }
}
